import { Link } from 'react-router';
import { APP_NAME } from '@sellit/shared';
import { Icon } from './Icon';

// VenLink brand kit logo (horizontal, for dark backgrounds) and the 10 Digits "Powered by" footer.
export function Wordmark({ className = 'brand' }: { className?: string }) {
  return (
    <p className={className}>
      <img className="brand-logo" src="/venlink-logo.png" alt={APP_NAME} width={621} height={120} />
    </p>
  );
}

export function PoweredBy({ showLogin = false }: { showLogin?: boolean }) {
  return (
    <footer className="site-footer">
      <img src="/10digits.png" alt="" width={40} height={31} />
      <span>Powered by the minds of <strong>10 Digits</strong></span>
      <nav className="footer-links" aria-label="Footer">
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/terms">Terms of Service</Link>
        {showLogin && <Link to="/admin">Seller log in</Link>}
      </nav>
    </footer>
  );
}

/** Shown to logged-in sellers viewing a sale the public can't see yet (or anymore). */
export function PreviewNotice({ status }: { status: 'DRAFT' | 'ARCHIVED' }) {
  return (
    <p className="notice preview" role="status">
      <Icon name="eye" />
      {status === 'DRAFT' ? 'Preview: this sale is a draft. Only its sellers can see it.' : 'Archived: this sale is hidden from the public.'}
    </p>
  );
}
